var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import mixin from '../../gui/components/mixin';
import { PAINTER_CONSTANTS } from '../constants';
import { AFRAME } from '../systems/brush';
import { GrabAndDropEvents } from '../systems/grabanddrop';
import { drawTextureOnCanvas, raiseCustomEvent } from '../util';
var THREE = window.THREE;
/* globals AFRAME THREE */
export default function () {
    AFRAME.registerComponent('canvasimage', __assign(__assign({ schema: {
            category: { type: 'string' },
            url: { type: 'string' },
            height: { type: 'number', default: 1 }, // Provide a default value for height
            width: { type: 'number', default: 1 } // Provide a default value for width
        } }, mixin), { init: function () {
            var _this = this;
            var me = this;
            var plane = document.createElement('a-plane');
            plane.setAttribute('height', "1");
            plane.setAttribute('width', "1");
            plane.setAttribute('position', "0 0 -1");
            plane.setAttribute('draganddropzone', {});
            me.plane = plane;
            me.el.appendChild(plane);
            this.updateElementSize(this, this.el);
            this.loadImage();
            me.el.addEventListener(GrabAndDropEvents.DROPPED_GRABBED_DATA, function (evt) { return __awaiter(_this, void 0, void 0, function () {
                var _a, data, category;
                return __generator(this, function (_b) {
                    _a = evt.detail, data = _a.data, category = _a.category;
                    if (me.data.category === category) {
                        if (data === null || data === void 0 ? void 0 : data.url) {
                            me.el.setAttribute('url', data === null || data === void 0 ? void 0 : data.url);
                            me.el.emit('change', { url: data === null || data === void 0 ? void 0 : data.url });
                        }
                    }
                    return [2 /*return*/];
                });
            }); });
        }, update: function (oldData) {
            // Only update if url has changed
            if (((oldData === null || oldData === void 0 ? void 0 : oldData.url) && oldData.url !== this.data.url) ||
                this.data.height !== oldData.height) {
                this.loadImage();
            }
        }, getWidth: function () {
            var _a;
            return parseFloat("".concat(((_a = this === null || this === void 0 ? void 0 : this.size) === null || _a === void 0 ? void 0 : _a.width) || this.data.width || 0));
        }, getHeight: function () {
            var _a;
            return parseFloat("".concat(((_a = this === null || this === void 0 ? void 0 : this.size) === null || _a === void 0 ? void 0 : _a.height) || this.data.height || 0));
        }, loadImage: function () {
            var _this = this;
            var me = this;
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            var image = new Image();
            image.crossOrigin = "anonymous"; // Handle cross-origin images
            image.onload = function () { return __awaiter(_this, void 0, void 0, function () {
                var aspectRatio, texture, material, height, width, mesh, layerDisplayEntity;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            canvas.width = image.naturalWidth;
                            canvas.height = image.naturalHeight;
                            context.drawImage(image, 0, 0);
                            aspectRatio = image.naturalWidth / image.naturalHeight;
                            texture = new THREE.Texture(canvas);
                            material = new THREE.MeshBasicMaterial({ map: texture, side: THREE.DoubleSide });
                            height = this.data.height;
                            width = this.data.height * aspectRatio;
                            this.width = width;
                            mesh = new THREE.Mesh(new THREE.PlaneGeometry(width, height), material);
                            me.size = {
                                height: height,
                                width: width
                            };
                            layerDisplayEntity = document.createElement('a-entity');
                            layerDisplayEntity.setObject3D('mesh', mesh);
                            if (me.plane) {
                                me.plane.parentNode.removeChild(me.plane);
                            }
                            me.plane = layerDisplayEntity;
                            me.el.appendChild(layerDisplayEntity);
                            return [4 /*yield*/, drawTextureOnCanvas(canvas, canvas.getContext('2d'), (_a = me.data) === null || _a === void 0 ? void 0 : _a.url)];
                        case 1:
                            _b.sent();
                            texture.needsUpdate = true;
                            raiseCustomEvent(PAINTER_CONSTANTS.CANVAS_IMAGE_CHANGED, { url: me.data.url, canvas: canvas });
                            me.el.emit(PAINTER_CONSTANTS.CANVAS_IMAGE_UPDATED, { url: me.data.url, canvas: canvas });
                            me.updateElementSize(this, this.el);
                            return [2 /*return*/];
                    }
                });
            }); };
            image.src = this.data.url;
        } }));
    AFRAME.registerPrimitive('frame-canvas-image', {
        defaultComponents: {
            'canvasimage': {}
        },
        mappings: {
            url: 'canvasimage.url',
            height: 'canvasimage.height',
            width: 'canvasimage.width',
            category: 'canvasimage.category'
        }
    });
}
